<template>

  <div class="hpanel hblue" v-if="user">
    <div class="panel-body">
      <div class="row">
        <div class="col-xs-8">
          <h3>{{user.firstname}} {{user.lastname}}</h3>
        </div>
        <div class="col-xs-4 text-center" style="height: 100px">
          <img alt="logo" class="img-circle" :src="getProfileImageUrl" style="height: 100px;width: 100px">
        </div>

      </div>
      <dl style="margin-bottom: 0">
        <dt>Email</dt>
        <dd>{{user.email}}</dd>
        <dt>Phone</dt>
        <dd v-if="user.phone">{{user.phone}}</dd>
        <dd v-else><p></p></dd>
      </dl>
      <dl>
        <dt>Organisation Name</dt>
        <template v-if="user.company && user.company.name">
        <dd >{{user.company.name}}</dd>
        <dt>Organisation Address</dt>
        <dd v-if="user.company && (user.company.address1 !== null || user.company.city !== null || user.company.zip_code !== null || user.company.country !== null)">
          <template v-if="user.company.address1">{{user.company.address1}}, </template>
          <template v-if="user.company.city">{{user.company.city}}, </template>
          <template v-if="user.company.zip_code">{{user.company.zip_code}}, </template>
          <template v-if="user.company.country">{{user.company.country.name}}</template>
        </dd>
        <dd v-else><p></p></dd>
        <dt>Activity overview</dt>
        <dd v-if="user.company && user.company.activity_overview" :title="user.company.activity_overview"
            v-html="user.company.activity_overview.length > 160 ? user.company.activity_overview.slice(0,160) + '...' : user.company.activity_overview"
            class="text-justify"></dd>
        <dd v-else><p></p></dd>
        </template>
        <template v-else>
          <dd class="m-t"> <i>Unknown</i>
            <label class="text-right text-info" @click="activeTab('company-tab')" style="cursor: pointer;"><i class="fas fa-pencil-alt"></i> Edit</label></dd>
        </template>
      </dl>
    </div>
    <div class="panel-body">
      <idx-radar v-if="radar" :stats="radar" :height="200"></idx-radar>
    </div>
    <div class="panel-body">
      <OIScore v-if="OIScore !== null" :OIScore="OIScore" :height="120" :legend="'Open Innovation score'"></OIScore>
    </div>

  </div>

</template>

<script>

import IdxRadar from '../charts/IdxRadar'
import OIScore from '../charts/OIScore'

export default {
  name: 'Overview',
  components: {IdxRadar, OIScore},
  props: ['user'],
  data () {
    return {
      radar: null,
      OIScore: null
    }
  },
  computed: {
    getProfileImageUrl: function () {
      let userPicture = this.$auth.user().picture
      let imgProfile

      if (userPicture === null) {
        imgProfile = this.$apiUrl + '/uploads/user/avatar.png'
      } else if (userPicture.indexOf('http') === 0) {
        imgProfile = userPicture
      } else {
        imgProfile = this.$apiUrl + '/uploads/user/profile/' + userPicture
      }

      return imgProfile
    }
  },
  beforeMount () {
    this.axios.get('/dashboard')
      .then((response) => {
        this.radar = response.data.radar
        this.OIScore = response.data.oi_score
      })
      .catch(function (error) {
      })
  },
  methods: {
    activeTab: function (tab) {
      $('.nav-tabs a[href="#' + tab + '"]').tab('show')
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/user/Overview.vue